import React, { useEffect, useState } from "react";
import GridList, { GridListItem } from "../Lists/GridList";
import Pill from "components/Text/Pill";
import { Link } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/outline";
//import { fromSqlDateTime } from "helpers/Date";
import { packClasses } from "Utils";
import { background as statusColors } from "constants/status-colors";
import flatCube from "assets/flat-cube.svg";
import EmptyState from "./EmptyState";

export default function ContentGrid(props) {
    const [selectedItems, setSelectedItems] = useState(
        props.selectedItems ? props.selectedItems : []
    );

    useEffect(() => {
        setSelectedItems(props.selectedItems);
    }, [props.selectedItems]);

    const bubbleClickAction = (item, checked) => {
        if (checked) {
            setSelectedItems([...selectedItems, item.uuid]);
        } else {
            setSelectedItems(selectedItems.filter((i) => i !== item.uuid));
        }
        if (props.onSelect) {
            return props.onSelect.call(null, item, checked);
        }
    };

    if (props.loading === true) {
        const loadingCells = [];
        for (let i = 0; i < 12; i++) {
            loadingCells.push(
                <GridListItem key={i}>
                    <div className="h-40 w-full animate-pulse rounded bg-gray-200">
                        &nbsp;
                    </div>
                </GridListItem>
            );
        }
        return <GridList>{loadingCells}</GridList>;
    }

    if (!props.items || !props.items.length) {
        return <EmptyState />;
    }

    return (
        <GridList>
            {props.items.map((item, index) => (
                <GridListItem key={index}>
                    <ContentGridItem
                        item={item}
                        onSelect={bubbleClickAction}
                        selected={
                            selectedItems
                                ? selectedItems.indexOf(item.uuid) > -1
                                : false
                        }
                    />
                </GridListItem>
            ))}
        </GridList>
    );
}

export function ContentGridItem(props) {
    const [selected, setSelected] = useState(props.selected ? true : false);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    // const statusColors = {
    //     published: "bg-green-600",
    //     pending: "bg-blue-500",
    //     draft: "bg-gray-300",
    // };

    const handleClick = (e) => {
        if (props.onSelect) {
            props.onSelect.call(null, props.item, e.target.checked);
        }
        setSelected(e.target.checked);
    };

    return (
        <div className="space-y-2">
            {props.item.attachment ? (
                <div
                    onClick={() => {
                        handleClick({ target: { checked: !selected } });
                    }}
                    className={packClasses(
                        selected
                            ? "ring-2 ring-green-500 ring-offset-2 ring-offset-gray-100"
                            : "",
                        "group aspect-w-10 aspect-h-7 z-0 block w-full cursor-pointer overflow-hidden rounded-lg bg-gray-100"
                    )}
                >
                    <img
                        src={props.item.attachment.imgix_url}
                        alt={props.item.attachment.uuid}
                        className="pointer-events-none object-cover group-hover:opacity-75"
                    />
                    <button
                        type="button"
                        className="focus:outline-none absolute inset-0"
                    >
                        <span className="sr-only">
                            {props.item.title ? (
                                props.item.title
                            ) : (
                                <span className="italic text-gray-600">
                                    Untitled
                                </span>
                            )}
                        </span>
                    </button>
                </div>
            ) : (
                <div
                    onClick={() => {
                        handleClick({ target: { checked: !selected } });
                    }}
                    className={packClasses(
                        selected
                            ? "ring-2 ring-green-500 ring-offset-2 ring-offset-gray-100"
                            : "",
                        "group aspect-w-10 aspect-h-7 block w-full cursor-pointer overflow-hidden rounded-lg bg-gray-100"
                    )}
                >
                    <img
                        src={flatCube}
                        alt={props.item.slug}
                        className="pointer-events-none object-cover group-hover:opacity-75"
                    />
                    <button
                        type="button"
                        className="focus:outline-none absolute inset-0"
                    >
                        <span className="sr-only">{props.item.title}</span>
                    </button>
                </div>
            )}{" "}
            <div className="flex space-x-2 align-middle">
                <Link
                    to={props.item.edit_url}
                    className="color-gray-400 block truncate text-sm hover:underline"
                >
                    {props.item.title}
                </Link>
            </div>
            <div className="flex space-x-2 align-middle">
                <div>
                    <span
                        className={packClasses(
                            "mx-0 inline-block h-3 w-3 rounded-full leading-none",
                            statusColors[props.item.status]
                        )}
                    >
                        &nbsp;
                    </span>
                </div>
                <Pill
                    className={packClasses(
                        "border border-transparent bg-gray-100 text-gray-700",
                        selected ? "border-gray-200" : ""
                    )}
                >
                    {props.item.type === "media"
                        ? props.item?.attachment?.type
                        : props.item?.type}
                </Pill>
                <Pill
                    className={packClasses(
                        "border border-transparent bg-gray-100 text-gray-700",
                        selected ? "border-gray-200" : ""
                    )}
                >
                    {props.item.workflow && props.item.workflow.uuid ? (
                        props.item.workflow.name
                    ) : (
                        <span className="text-gray-300">None</span>
                    )}
                </Pill>
                {props.item.lock && props.item.lock.user && (
                    <Pill
                        className={packClasses(
                            "border border-transparent bg-gray-100 text-red-700",
                            selected ? "border-gray-200" : ""
                        )}
                    >
                        <LockClosedIcon className="my-0.5 h-2.5 w-2.5" />
                    </Pill>
                )}
            </div>
            {/*<div className="flex flex-col space-y-1">
                <div className="text-xs">
                    Edited:{" "}
                    {fromSqlDateTime(props.item.modified_at).toFormat("ff")}
                </div>
                        </div>*/}
        </div>
    );
}
